import { message } from "antd";
import React, { useEffect, useState } from "react";
import { BiRevision } from "react-icons/bi";
import { useAuth } from "../../hooks/auth";
import { api } from "../../services/api";
import { Load } from "../Load";
import { Content } from "./styles";
import QrCode from "qrcode.react";
import { socket } from "../../services/socket";
interface Props {}
export function WhatsappQrCode({ ...rest }: Props) {
  const { user } = useAuth();
  const [loading, setLoading] = useState(true);
  const [qrCode, setQrCode] = useState("");
 
  function fetchData() {
    api
      .post("whatsapp", {
        id: user.id,
      })
      .catch((e) => {
        message.error(e.response.data.message);
        setLoading(false)
      })
      
  }
  useEffect(fetchData, []);
  useEffect(() => {
    socket.on("qr", (qr) => {
      setQrCode(qr);
    });
  }, []);
  return (
    <Content>
      <div className="toconnect">
        <div className="instructions">
          <span>1. Abra o WhatsApp no seu celular.</span>
          <span>
            2. Toque em Mais opções ou Configurações e selecione Aparelhos
            conectados.
          </span>
          <span>
            3. Aponte seu celular para esta tela para capturar o código.
          </span>
        </div>
        <div className="qr">
          {qrCode ? (
               <QrCode
               id="CodeQr"
               value={qrCode}
               size={200}
               level={"L"}
               includeMargin={true}
             />
          ) : loading ? (
            <Load />
         
          ) : (
            <div className="reloading" onClick={fetchData}>
              <BiRevision />{" "}
            </div>
          )}
        </div>
      </div>
    </Content>
  );
}
